import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OrganicRouteGuard  {

	constructor(private readonly router: Router) { }

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const errorDetail = this.router.getCurrentNavigation()?.extras.state;
		if (this.router.url === `/` && !errorDetail) {

			return this.router.parseUrl('/');
		}

		return true;
	}

}
